import './labels.css';

export const Error = ({ children }) => {
    return (
        <div className="labels-error">
            {children}
        </div>
    )
}
